var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFreeBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 370,
    height: 193,
    viewBox: "0 0 370 193",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFD495",
    width: 370,
    height: 193,
    rx: 22
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.497
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242 82h100v100H242z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.284 86.598a4.16 4.16 0 0 1 4.16 4.16v4.16h20.798v24.958h-8.397l11.422 31.381a16.597 16.597 0 0 1 1.135 6.054c0 9.19-7.45 16.639-16.639 16.639-7.752 0-14.265-5.3-16.114-12.475H286.96c-1.847 7.176-8.362 12.479-16.115 12.479-8.089 0-14.83-5.772-16.328-13.421a8.319 8.319 0 0 1-4.471-7.378v-41.598a4.16 4.16 0 0 1 4.16-4.16h29.119a4.16 4.16 0 0 1 4.16 4.16v20.799a4.16 4.16 0 0 0 4.16 4.16h8.319a4.16 4.16 0 0 0 4.16-4.16V94.917h-12.48v-8.32h16.64zm-37.439 62.397a8.32 8.32 0 1 0 0 16.64 8.32 8.32 0 0 0 0-16.64zm49.918-.004a8.32 8.32 0 1 0 7.82 5.473l-.068-.18a8.323 8.323 0 0 0-7.752-5.293zm-4.771-29.115h-3.549v12.48c0 6.892-5.587 12.48-12.48 12.48h-8.319c-6.892 0-12.48-5.588-12.48-12.48h-20.798v13.953a16.6 16.6 0 0 1 12.48-5.634c7.752 0 14.267 5.303 16.114 12.48h17.687c1.846-7.179 8.361-12.484 16.116-12.484.985 0 1.95.086 2.888.25l-7.66-21.045zm-36.827-4.16h-20.8v8.32h20.8v-8.32zm45.758-12.479h-12.48v8.32h12.48v-8.32z",
    fill: "#FFF",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    opacity: 0.5,
    x: 99,
    y: 174,
    width: 251,
    height: 5,
    rx: 2.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    opacity: 0.5,
    transform: "matrix(-1 0 0 1 118 0)",
    x: 30,
    y: 174,
    width: 58,
    height: 5,
    rx: 2.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeBanner);
export default __webpack_public_path__ + "static/media/free-banner.73f847a5b318b3bc81549cfd09d8cdff.svg";
export { ForwardRef as ReactComponent };